import React, { useState } from 'react'
import imageLogo from "../assets/logo_ticket_win.png";
import { FaPlusCircle, FaSignOutAlt, FaTicketAlt } from 'react-icons/fa'; // Importa los íconos que desees
import { IoCloseCircleSharp } from "react-icons/io5";
import { handleLogout } from "../utils";
import { authFB } from '../firebase';
import packageJson from "../../package.json"

const SidebarDash = () => {
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    
  return (
    <>
        <div className="">
        <button 
          className="md:hidden p-4 bg-colors-container text-white w-full font-bold"
          onClick={() => setIsSidebarOpen(!isSidebarOpen)}
        >
          {isSidebarOpen ? 'Cerrar' : 'Menu'}
        </button>
      </div>

      <aside className={`z-10 fixed inset-0 bg-colors-container text-white min-h-screen p-4 transition-transform transform ${isSidebarOpen ? 'translate-x-0' : '-translate-x-full'} md:relative md:translate-x-0 md:w-1/4`}>
       
        <div className="flex justify-between items-center">
          <img src={imageLogo} alt="TicketWin APP" width={"150px"} />
          <button 
            className="md:hidden text-white flex gap-1 items-center"
            onClick={() => setIsSidebarOpen(false)}
          >
           <IoCloseCircleSharp />
           Cerrar
          </button>
        </div>
      <div className='mt-4'>
      
      <small>v{packageJson.version}</small>
      <h2 className="text-xl font-bold mb-4">Dashboard</h2>
      <h1 className='mb-4'>Usuario: {authFB.currentUser?.email}</h1>

        <ul className="ml-3">
          <li className="mb-4 flex items-center">
            <FaTicketAlt className="mr-2" />
            <a href="/raffles" className="hover:underline">Mis Rifas</a>
          </li>
          <li className="mb-4 flex items-center">
            <FaPlusCircle className="mr-2" />
            <a href="/create" className="hover:underline">Crear Rifa</a>
          </li>
          <li className="mb-4 flex items-center" onClick={handleLogout}>
            <FaSignOutAlt className="mr-2" />
            <span className="hover:underline cursor">Cerrar sesión</span>
          </li>
        </ul>
      </div>
     
      </aside>
    </>
  )
}

export default SidebarDash
